export default "__VITE_PUBLIC_ASSET__dcace2d6__"